import { useContext,  useState } from "react"
import API from "./API"
import { Link, useNavigate, useParams } from "react-router"
import { useForm } from "react-hook-form"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ModalContext } from './ModalContext';
import ApiResult from './ApiResult';
import { AdminQueryDivision, AdminQueryUsage } from "../../backend/src/api/dto"
import ModalConfirmation from "./Modal/Confirmation"
import DisplayUsage from "./components/DisplayUsage"

type FormValues = {
    name: string
    description: string
    status: boolean
}


function Division() {

    const params = useParams();
    let navigate = useNavigate();

    const [data, setData] = useState<{
        division: AdminQueryDivision,
        usage: AdminQueryUsage[],
    }>({
        division: {
            divisionId: 0,
            name: '',
            description: '',
            status: false
        },
        usage: []
    })
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(false)
    const { register, control, getValues } = useForm<FormValues>({
        defaultValues: async () => {
            if (params.divisionId !== "0") {
                setLoading(true)
                const division = await API.getDivision(params.divisionId ?? 0)
                setData(prevData => {
                    return {
                        ...prevData,
                        ...division
                    }
                })
                setLoading(false)
                return division.division
            }
            return {
                status: true,
                name: '',
                description: ''
            }
        }
    })

    const reloadData = (): Promise<any> => {
        setLoading(true)
        return API.getDivision(params.divisionId ?? 0).then(division => {
            setData(prevData => {
                return {
                    ...prevData,
                    ...division,

                }
            })
            setLoading(false)
        }).catch(e => {
            setLoading(false)
        })
    }


    const addDivision = () => {
        API.addDivision(getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/center')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }

    const saveDivision = () => {
        API.saveDivision(params.divisionId ?? 0, getValues()).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/center')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }


    const deleteDivision = () => {
        return API.deleteDivision(params.divisionId ?? 0).then((res) => {
            console.log(res)
            setApiResult(null)
            navigate('/dashboard/center')
        }).catch((e) => {
            console.log(JSON.stringify(e))
            setApiResult(e)
        })
    }


    if (loading) {
        return (
            <div className="p-3">
                <div className="card">
                    <div className="card-header" style={{ height: '55px' }}>
                        <div className="mt-2">Stredisko: ...</div>
                    </div>
                    <div className="card-body">
                        Nahrávam
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header " style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-1">
                            <span className=""><Link to="/dashboard/center" className="btn btn-primary"><FontAwesomeIcon fixedWidth icon={["fas", "arrow-left"]} /> Späť</Link></span>
                        </div>
                        <div className="col-6">
                            <div className="mt-2">Divízia: <strong>{
                                params.divisionId === "0" ? '[ Vytvoriť novú ]' : getValues().name
                            }</strong></div>
                        </div>
                        <div className="col-5 text-end">
                            {
                                params.divisionId === "0" ?
                                    <button className="btn btn-primary" onClick={addDivision}><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} />  Pridať divíziu</button>
                                    :
                                    <>
                                        {
                                            !loading && !data.usage.length ?
                                                <button className="btn btn-danger me-3" onClick={() => showModal(
                                                    <ModalConfirmation
                                                        confirm={deleteDivision}
                                                        title={"Naozaj zmazať divíziu?"}
                                                        text="" />
                                                )}><FontAwesomeIcon fixedWidth icon={["fas", "trash"]} />  Zmazať divíziu</button>
                                                : null
                                        }
                                        <button className="btn btn-primary" onClick={saveDivision}><FontAwesomeIcon fixedWidth icon={["fas", "floppy-disk"]} />  Uložiť divíziu</button>

                                    </>

                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <ApiResult errorObject={apiResult} />
                    <div className="row">
                        <div className="col-4">
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Názov divízie</label>
                                </div>
                                <div className="col-auto">
                                    <input type="text" {...register("name")} className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 mt-1 text-end">
                                    <label className="form-label">Popis</label>
                                </div>
                                <div className="col-8">
                                    <textarea rows={6} {...register("description")} className="form-control form-control-sm" />
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-4  mt-1 text-end">
                                    <label className="form-label">Aktívna</label>
                                </div>
                                <div className="col-8  mt-1">
                                    <div className="form-check">

                                        <input className="form-check-input" {...register("status")} type="checkbox" />
                                        <label className="form-check-label">

                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div className="offset-4 col-4">
                            {
                                params.centerId !== "0" ?
                                    <>
                                        <h4>Odkazy na túto divíziu</h4>
                                        <DisplayUsage data={data.usage} />
                                    </>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Division